import React, { useCallback, useMemo, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { LobbyIcon } from './lobby-icon';
import { applicationStore } from '../../store/applicationStore';
import './lobby.scss';

export const LobbyWrapper = observer(() => {
  const { iconsInfo } = applicationStore;
  const lobbyIconContainerRef = useRef(null);
  const imgOptions = useMemo(() => iconsInfo?.find((item) => item.type === 'Lobby'), [iconsInfo]);

  const lobbyIconPostMessage = useCallback((e) => {
    if (e.target.type) {
      window.parent.postMessage({ name: 'onOpenerIconClick', type: 'Lobby' }, '*');
    }
  }, []);

  if (!imgOptions) {
    return null;
  }
  return (
    <LobbyIcon
      image={imgOptions?.imageUrl}
      lobbyIconContainerRef={lobbyIconContainerRef}
      lobbyIconPostMessage={lobbyIconPostMessage}
    />
  );
});
